import React from 'react';
import Hnavbar from '../components/JSX/Hnavbar';
import Slider1 from '../components/JSX/Slider1';
import Services from '../components/JSX/Services';
import Featured from '../components/JSX/Featured';
import Clients from '../components/JSX/Clients';
import News from '../components/JSX/News';
import Footer from '../components/JSX/Footer';

const Home = () => (
  <>
    <Hnavbar />
    <Slider1 />
    <Services />
    <Featured />
    <Clients />
    <News />
    <Footer/>
  </>
);

export default Home;